import { GetStaffPersonaParams, StaffPersona } from "@godalming/api-types";
import { portalApi } from "@services/api/portalApi";
import { StudentPersona, UserPhoto } from "@godalming/api-types";

export async function getStudentPersona(id: string, signal?: AbortSignal) {
    const res = await portalApi.get<StudentPersona>(`/personas/student/${encodeURIComponent(id)}`, {
        signal,
    });
    return res.data;
}

export async function getStaffPersona(params: GetStaffPersonaParams, signal?: AbortSignal) {
    const res = await portalApi.get<StaffPersona>(`/personas/staff/${encodeURIComponent(params.identifier)}`, {
        params: params.identifierType ? { identifierType: params.identifierType } : undefined,
        signal,
    });
    return res.data;
}

export async function getStudentPhoto(id: string, signal?: AbortSignal) {
    const res = await portalApi.get<UserPhoto>(`/personas/student/${encodeURIComponent(id)}/photoUrl`, {
        signal,
    });
    return res.data;
}
